import React, { Component } from 'react';
import PropTypes from 'prop-types';

import LinearProgress from 'material-ui/LinearProgress';
import DetailView from '../Common/DetailView';
import { List } from 'material-ui/List';
import StatementListItem from '../LearningRecordStore/StatementListItem';

import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import SkillIcon from 'material-ui/svg-icons/social/public';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import ActivityIcon from 'material-ui/svg-icons/action/timeline';
import ModuleIcon from 'material-ui/svg-icons/action/view-module';

import ActivityStore from '../../stores/ActivityStore';
import LRS from '../../utils/LRS.js';

import buildContextMenu from '../Common/BuildContextMenu';

const style = {
    list: {
        paddingBottom: 0,
    },
};

class MyActivities extends Component {

    constructor(props, context) {
        super(props);
        this.state = {
            activities: (<div><LinearProgress mode="indeterminate" /></div>),
            actions: buildContextMenu(this.getActions(), context.auth),
        };
    }

    getActions() {
        return [
            {
                link: '/dashboard/mytraining',
                icon: <SchoolIcon />,
                label: 'My training',
            },
            {
                link: '/dashboard/mytraining/skills',
                icon: <SkillIcon />,
                label: 'My skills',
            },
            {
                link: '/dashboard/mytraining/courses',
                icon: <SchoolIcon />,
                label: 'My courses',
            },
            {
                link: '/dashboard/mytraining/modules',
                icon: <ModuleIcon />,
                label: 'My modules',
            },
            {
                link: '/dashboard/mytraining/resources',
                icon: <LibraryIcon />,
                label: 'My resources',
            },
            {
                link: '/dashboard/mytraining/activities',
                icon: <ActivityIcon />,
                label: 'My Activities',
            },
            {
                type:'divider'
            },
            {
                link: '/logout',
                icon: <CancelIcon />,
                label: 'Sign out',
            },
        ];
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.listener = ActivityStore.addListener(this.onChange);
        LRS.getUserActivity(this.context.auth.identity.id);
    }

    componentWillUnmount() {
        this.listener.remove();
    }

    render() {

        return (

            <DetailView
                title='My activities'
                actions={this.state.actions}
            >
                <div className="cent-list-wrapper">
                    <List style={style.list} className='cent-list'>
                    {this.state.activities}
                    </List>
                </div>
            </DetailView>
        )
    }

    onChange() {
        const activities = ActivityStore.getByUser(this.context.auth.identity.id);
        if (activities !== undefined) {
            const entries = activities
                .filter((e) => {
                    if (e !== undefined) {
                        let verb = e.verb.id.split('/').pop();
                        return verb === 'passed' || verb === 'failed';
                    }
                    return false;
                })
                .sort((a, b) => b.datetime - a.datetime )
                .map((e) => (
                        <StatementListItem statement={e} key={e.id} />
                ));
            this.setState({activities: entries});
        }
    }
}

MyActivities.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default MyActivities;
